import { Injectable, inject, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  IClinicalChart,
  IPerioRecord,
  IPerioTableCell,
} from '@principle-theorem/principle-core/interfaces';
import { serialise, WithRef } from '@principle-theorem/shared';
import {
  deletePerioValues,
  upsertPerioChart,
  upsertPerioValue,
} from '../actions/perio-table';
import { ChartId } from '../reducers/active-charts/chart-context-state';
import { type IChartState } from '../reducers/reducers';

@Injectable({
  providedIn: 'root',
})
export class PerioChartFacade {
  private _store = inject(Store<IChartState>);
  compareChart = signal<WithRef<IClinicalChart> | undefined>(undefined);

  setCompareChart(chart: WithRef<IClinicalChart> | undefined): void {
    this.compareChart.set(chart);
  }

  upsertPerioChart(perioRecords: IPerioRecord[]): void {
    this._store.dispatch(
      upsertPerioChart(serialise({ id: ChartId.InAppointment, perioRecords }))
    );
  }

  upsertPerioValue(changes: IPerioTableCell[]): void {
    this._store.dispatch(
      upsertPerioValue(serialise({ id: ChartId.InAppointment, changes }))
    );
  }

  deletePerioValues(cells?: IPerioTableCell[]): void {
    this._store.dispatch(
      deletePerioValues(serialise({ id: ChartId.InAppointment, cells }))
    );
  }
}
